import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { AvatarTypes, SpaceEntitlementType } from '@mode/shared/contract-common';

@Component({
  selector: 'mode-accessor-name',
  templateUrl: './accessor-name.component.html',
  styleUrls: ['./accessor-name.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessorNameComponent {
  @HostBinding('class') classes = 'mode-accessor-name';

  @Input()
  avatar: AvatarTypes.Avatar;

  @Input()
  link = '';

  @Input()
  name: string;

  @Input()
  target = '_blank';

  @Input()
  type: SpaceEntitlementType;
}
